import { Injectable, EventEmitter } from '../../helpers';

/**
 * @class EventsBrokerPmsApiService
 * @property {Scope} $rootScope
 */
export class EventsBrokerPmsApiService extends Injectable {

    static get ERROR_TYPE_SUBSCRIPTION() {

        return 'subscription';
    }

    static get SUBSCRIPTION_IS_SUSPENDED() {

        return 'subscription_is_suspended';
    }

    static get SUBSCRIPTION_WITHOUT_ACCOUNT_SETUP() {

        return 'subscription_without_account_setup';
    }

    static get EVENT_UNAUTHENTICATED() {
        
        return 401;
    }
    
    static get EVENT_UNAUTHORIZED() {
        
        return 403;
    }
    
    static get EVENT_FATAL_ERROR() {
        
        return 500;
    }

    static get $inject() {

        return [ '$rootScope' ];
    }

    constructor(...injected) {

        super(...injected);

        /**
         * @type {EventEmitter}
         */
        this.events = new EventEmitter(this.$rootScope, 'pms-api.');
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/events-broker.service.js